<template>
  <!-- list-container -->
  <div ref="container">
    <div
      v-for="(item, id) in list"
      :key="id"
      :class="getClass(id)"
      @mouseenter="highlightItem(id)"
      @mouseleave="highlightItem(null)"
      @click="openDetail(id, $event)"
      v-html="item"
    />
  </div>
</template>

<script>
export default {
  name: 'DsioList',
  props: {
    list: {
      type: [Object, Array],
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      classItem: null,
    };
  },
  watch: {
    list (list) {
      // toggle empy class
      list.empty ? this.$refs['container'].classList.add('empty') : this.$refs['container'].classList.remove('empty');
    },
  },
  mounted () {
    // const container = this.$refs['container'];
    // if (container.children.length > 0) {
    //   this.classItem = [...container.firstElementChild.classList, 'list-item'];//toujours avoir list-item
    // }
  },
  methods: {
    getClass (id) {
      return ['list-item', 'list-item-' + id];
    },
    highlightItem (id) {
      if (id !== 'empty') {
        this.dispatch('highlightItem', id);
      }
    },
    openDetail (oiId, ev) {
      if (oiId.substring(0, 3) !== 'TFO') {
        return;
      }

      let prms = {};

      // TODO supprimer dépendance à jQuery
      // ne pas ouvrir si click sur lien
      if (typeof jQuery !== 'undefined') {
        const $target = jQuery(ev.target);
        if ($target.is('a:not(".dsio-detail-button")') || $target.parents('a:not(.dsio-detail-button):first').length) {
          return;
        } else {
          const $a = $target.is('a.dsio-detail-button') ? $target : $target.parents('a.dsio-detail-button:first');
          if ($a.length) { // sur bouton
            prms.hash = $a.attr('href').split('#')[1];
          } else { // clic sur list-item
            prms.hash = $target.parents('.list-item:first').find('a.dsio-detail-button:first').attr('href').split('#')[1];
          }
        }
      }

      let popupOpen = this.app.params.detailPopup;
      let href = null;

      // récupération du lien dans le dom
      // el avec class dsio-detail-button
      const $link = document.getElementsByClassName('list-item-' + oiId)[0].getElementsByClassName('dsio-detail-button')[0];

      // vérification du lien
      if (typeof $link !== 'undefined') {
        href = $link.getAttribute('href');

        // ouverture hors popup pour les liens http
        if (href.indexOf('http') === 0) {
          popupOpen = false;
        }
      }

      // empecher le clic car gestion manuelle
      ev.preventDefault();

      if (popupOpen) {
        this.commit('UPDATE_DETAIL', { oiId, prms });
      } else if (href) {
        $link.getAttribute('target') === '_blank' ? window.open(href) : window.location.href = href;
      }
    },
  },
};
</script>
